module.exports = __webpack_public_path__ + "warm_welcome.17fe9c88357031f6723f.png";


//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/assets/images/warm_welcome.png
// module id = ../../../../../src/assets/images/warm_welcome.png
// module chunks = 8